import { Dispatch, RefObject, SetStateAction, useEffect, useState } from 'react';
import { useClickOutside } from './useClickOutside';

export const useContextMenuState = (
    element: RefObject<HTMLElement | null>,
    options = { escape: true, clickOutside: true }
): [boolean, Dispatch<SetStateAction<boolean>>] => {

    const [isOpen, setOpen] = useState(false);

    useClickOutside(element.current, () => {
        if (options.clickOutside) {
            setOpen(false);
        }
    });

    useEffect(() => {
        if (options.escape) {
            if (isOpen) {
                const onKeyDown = (event: any) => {
                    if (event.key === 'Escape') {
                        setOpen(false);
                    }
                };
                document.addEventListener('keydown', onKeyDown);
                return () => document.removeEventListener('keydown', onKeyDown);
            }
        }
    }, [isOpen, options.escape, setOpen]);

    return [isOpen, setOpen];
};